import { Activity, Clock3 } from "lucide-react"

export interface ProfileActivityItem {
  id: string
  user_name?: string | null
  action?: string | null
  table_name?: string | null
  summary?: string | null
  created_at?: string | null
}

const formatDateTime = (value?: string | null) => {
  if (!value) return "Unknown time"
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return "Unknown time"
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  })
}

const titleCase = (value?: string | null) =>
  (value || "Record")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase())

export function ProfileActivityTimeline({
  title = "Activity logs",
  logs,
  emptyText = "No activity has been logged yet.",
  compact = false,
}: {
  title?: string
  logs: ProfileActivityItem[]
  emptyText?: string
  compact?: boolean
}) {
  return (
    <section className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
      <div className="flex items-center gap-2 border-b border-slate-100 bg-slate-50 px-4 py-3">
        <Activity className="h-4 w-4 text-[#89A8B2]" />
        <h3 className="text-sm font-semibold text-slate-800">{title}</h3>
      </div>

      {logs.length === 0 ? (
        <div className="px-4 py-8 text-center text-sm text-slate-500">{emptyText}</div>
      ) : (
        <ul className="divide-y divide-slate-100">
          {logs.map((row) => (
            <li key={row.id} className={compact ? "px-4 py-2.5" : "px-4 py-3"}>
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-slate-800">
                    {row.summary || `${titleCase(row.action)} ${titleCase(row.table_name)}`}
                  </p>
                  <p className="mt-0.5 text-xs text-slate-500">
                    By {row.user_name || "System"} · {titleCase(row.table_name)}
                  </p>
                </div>
                <span className="inline-flex shrink-0 items-center gap-1 rounded-full bg-slate-100 px-2 py-1 text-[11px] font-medium text-slate-600">
                  <Clock3 className="h-3 w-3" />
                  {formatDateTime(row.created_at)}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
